<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="Work-Order-material-issues-list"
    :setLoading="setLoading"
    ref="work-order-material-issues-list"
  >
    <template #popup>
      <GcPopupMaterialIssue
        :popupConfig="materialPopupInfo"
        :on-hide="onPopupHide"
        v-if="materialPopupInfo.isPopupShow"
        :showLoading="ShowLoading"
        @onRefreshDataList="onRefreshDataList"
        :popup-mode="materialPopupInfo.popupMode"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
// import { WorkOrderService } from "@/_services/api/production/work-order.service";
import {
  GetIndexByTabName,
  WorkOrderTabs,
} from "../../../_models/tabdata/production/work-order-tabs";
import { getBranchFieldDefault } from "../../../_helpers/default-value-rules/default-value-rules";
// import { ProductionReleaseService } from "../../../_services/api/production/production-release.service";
import GcPopupMaterialIssue from "../../../popups/work-order/gc-popup-material-issue .vue";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    GcPopupMaterialIssue,
  },
  data() {
    return {
      transactionListKey: 0,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
      },
      initialModel: null, // To store the initial state
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        // toolbarMenuItems: [
        //   {
        //     menuText: "Copy",
        //     visible: false, // pending discussions #54331
        //   },
        //   { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        //   { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        //   { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        // ],
        formMode: "create",
        isEditable: false,
        dataModel: {
          BranchCode: undefined,
          ReleaseDate: undefined,
        },
      },
      setLoading: false,
      dataModel: undefined,
      WorkOrderInstance: "Core",
      materialPopupInfo: {
        isPopupShow: false,
        dataModel: {},
        popupMode: "create", // or 'view' based on the context
      },
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Work Orders",
        ScreenName: "Work Orders Material Issues",
        exportFileName: "Work Order List - Material Issues",
        selectedIndex: GetIndexByTabName("Material Issues"),
        tabs: WorkOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "MaterialIssueList",
              //   filter: [[["FriendlyStatus", "=", "Completed"]]],
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Material Issues",
                message: "Get Started, Add a Material Issue",
              },
            },
            // options: {
            //   selectionMode: "multiple",
            // },
          },
          toolbar: {
            screenName: "Work Orders Material Issues",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: this.onNewMaterialHandler,
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "WorkOrderMaterialIssue",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Release",
              label: "Issue No",
              dataField: "IssueNo",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              sortIndex: 0,
              sortOrder: "desc",
              filterIndex: 1,
              type: "Integer",
              filterLabel: "Issue No",
              filterDataField: "IssueNo",
            },
            {
              screenField: "Code",
              filterLabel: "Work Order",
              label: "Work Order",
              gridDataField: "WorkOrderCode",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              filterIndex: 2,
              type: "Integer",
              filterDataField: "WorkOrderCode",
              sortIndex: 1,
              sortOrder: "desc",
            },
            {
              screenField: "Product",
              gridDataField: "PlannedProductDescription",
              label: "Planned Product",
              minWidth: ColumnWidth.ProductOrAccount.minWidth,
              width: ColumnWidth.ProductOrAccount.width,
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "PlannedProductDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "PlannedProductCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "PlannedProductCode",
                  label: "Product Code",
                },
                {
                  dataField: "PlannedProductDescription",
                  label: "Product Description",
                },
              ],
              filterIndex: 5,
              filterDataField: "PlannedProductCode",
              filterLabel: "Planned Product",
              filterOverWrites: {
                select: [
                  "Code",
                  "Description1",
                  "Inactive",
                  "Status",
                  "Source",
                ],
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },
            {
              screenField: "ItemCount",
              label: "Line Count",
              gridDataField: "LineCount",
              minWidth: ColumnWidth.LineNo.minWidth,
              width: ColumnWidth.LineNo.width,
            },
            {
              screenField: "DateIn",
              dataField: "IssueDate",
              filterDataField: "IssueDate",
              label: "Issue Date",
              filterIndex: 3,
            },
            {
              screenField: "DateCreated",
              filterIndex: 4,
            },
            {
              screenField: "CreatedBy",
            },
            {
              screenField: "Status",
              gridDataField: "Status",
              cellTemplate: "Status",
            },
            {
              screenField: "Product",
              gridDataField: "MaterialProductList",
              label: "Material Product",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 6,
              filterLabel: "Material Product",
              filterDataField: "MaterialProductList",
              filterOperator: "contains",
            },
          ],
        },
      };
    },
  },
  async created() {
    await this.loadWorkOrderInstance();
  },
  methods: {
    async loadWorkOrderInstance() {
      let workOrderInstanceSetting = await SettingsService.getBySettingName(
        "WorkOrderInstance"
      );

      if (workOrderInstanceSetting.data.value.length > 0) {
        this.WorkOrderInstance =
          workOrderInstanceSetting.data.value[0].SettingValue;
      }
    },
    onRefreshDataList() {
      this.$refs["work-order-material-issues-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popup.dataModel = {};
      this.popup.isPopupShow = false;
      this.materialPopupInfo.isPopupShow = false;
    },

    /**
     * On New Work Order Handler
     */
    async onNewMaterialHandler() {
      this.materialPopupInfo.popupKey++;
      this.materialPopupInfo.dataModel.BranchCode = await getBranchFieldDefault(
        this.$store
      );
      this.materialPopupInfo.hideOnOutsideClick = false;

      this.materialPopupInfo.dataModel.ReleaseDate = new Date();
      this.materialPopupInfo.formMode = "create";
      this.materialPopupInfo.popupMode = "create";

      this.materialPopupInfo.isPopupShow = true;
    },

    /**
     * On Row Click CallBack
     * @param e
     */
    async rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "Status" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.type !== "selection"
      ) {
        const rowData = e.data;
        this.materialPopupInfo.popupMode = "review";
        this.materialPopupInfo.dataModel = {
          IssueDate: new Date(),
          IssueNo: rowData.IssueNo,
        };
        this.materialPopupInfo.isPopupShow = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
